import {Component} from 'react';
import "../css-files/moneyBuilder.css";
import "../css-files/moneyBuilderMedia.css";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import SavingsGeneralDisplay from './savings_general_display';
import SavingsSetupIntro from './text/savings_setup_intro_text';
import SavingsPolicyOptions from './datasets/savings_policy_options';
import SetupSavingsCardDisplay from './setup_savings_card _display';
import SavingsCDList from './savings_CD_list';
import checkCDListForChanges from './objects/check_CD_List_For_Changes';

class SetupSavingsModal extends Component {
        constructor(props) {
        super(props);
        this.state={
            displayInstructions: false,
            openFriendModal: false,
            rerender: null,
        } 
        this.policyOptionsArr = [];
        this.savingsPolicyData = SavingsPolicyOptions;
        this.fieldInError = false;
        this.dataChanged = false;
        this.amountError = null;
        this.amountErrorArr = [];
        this.oneTimeAmtError = "";
        this.monthlyAmtError = "";
        this.transferAmtError = "";
        this.chgAutoRollover = true;
        this.transferNotRecommended = false
        this.transferFee = 0;
        this.initializeFields();  
    }
    
    initializeFields(){
        this.introText1 = SavingsSetupIntro.summaryText;
        this.introText2 = SavingsSetupIntro.moreInformation;
        this.savingsType = this.props.savingsInfo.savingsType
        this.savingsPolicyData = 
            this.savingsPolicyData.find(elem => elem.type === this.props.savingsInfo.savingsType);
        this.savingsTypeLabel = this.savingsPolicyData.longName;
    }
    
    onMonthlyDeposit(monthlyDepositAmount){
        if (isNaN(+monthlyDepositAmount) || !monthlyDepositAmount){
            monthlyDepositAmount = 0;
        }
        this.processDepositAmount("Monthly amount", "monthlyDepositAmt", monthlyDepositAmount);
    }
    
    onOneTimeDeposit(oneTimeDepositAmount){
        if (isNaN(+oneTimeDepositAmount) || !oneTimeDepositAmount){
            oneTimeDepositAmount = 0;
        }
        this.processDepositAmount("One-time amount", "oneTimeDepositAmt", oneTimeDepositAmount);
    }
    
    transferAmount(newTransferAmount){
        if (isNaN(+newTransferAmount) || !newTransferAmount){
            newTransferAmount = 0;
        }
        this.processDepositAmount("Transfer amount", "newTransferAmt", newTransferAmount);
    }

    autoRollover(autoRolloverOption){
        const actualBoolean = autoRolloverOption === true || autoRolloverOption === "true";
        this.processDepositAmount("", "autoRollover", actualBoolean);
    }

    processDepositAmount(fieldLabel, fieldName, value){
        this.dataChanged = true;
        this.resetErrorMsgs(fieldName);
        let returnObj = {
            savingsClass: this.props.savingsClass,
            savingsType: this.props.savingsInfo.savingsType, 
            fieldName:  fieldName, 
            value: value};
        this.props.saveDepositAmounts(returnObj);
        this.amountError = false;
        if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
            if (this.fieldName !== "autoRollover"){
                this.editAmount(fieldLabel, fieldName, value);
            }
            this.setState({errorsFound: this.amountError});
        }, 500);
    }

    resetErrorMsgs(fieldName){
        if (this.amountErrorArr.includes (fieldName)){
            this.amountErrorArr = this.amountErrorArr.filter(item => item !== fieldName);
        }
        this.fieldInError = false;
        if (fieldName === "oneTimeDepositAmt"){
            this.oneTimeAmtError = "";
        }
        if (fieldName === "monthlyDepositAmt"){
            this.monthlyAmtError = "";
        }
        if (fieldName === "newTransferAmt"){
            this.transferAmtError = "";
        }
    }

    editAmount(fieldLabel, fieldName, amount){
        if (isNaN(amount)){
            const errorMsg = fieldLabel + " must be a valid number."
            this.setErrorMsg(fieldName, errorMsg);
        }else{
            if (+amount < 0){
                const errorMsg = fieldLabel + " must be greater than 0."
                this.setErrorMsg(fieldName, errorMsg);
            }
        }
        if (this.fieldInError === false){
            this.editsByFieldName(fieldName, amount);
        }        
        if (this.fieldInError === false){
            this.editsBySavingsType(fieldLabel, fieldName, amount);
        }
        if (fieldName === "newTransferAmt" && +amount === +this.props.savingsInfo.totalSavingsAmt){
            this.displayMsg = "This account will be closed - full balance withdrawn."
        }
        if (this.amountErrorArr.length === 0){
            this.amountError = false;
        }else{
            this.amountError = true;
        }
    }

    editsByFieldName(fieldName, amount){
        switch (fieldName){
            case "newTransferAmt":
                if (+amount > +this.props.savingsInfo.totalSavingsAmt){
                    const errorMsg = "Transfer amount is greater than current amount saved.";
                    this.setErrorMsg(fieldName, errorMsg);
                } 
                break;   
            case "monthlyDepositAmt":
                if (+amount > 0 && +amount < 50.00){
                    const errorMsg = "Monthly Deposit Amount must be greater than $50";
                    this.setErrorMsg(fieldName, errorMsg);
                }
                break;
            default:
                break;
        }
    }

    editsBySavingsType(fieldLabel, fieldName, amount){
        if (this.props.savingsInfo.savingsType === "CD"){
            if (fieldName === "oneTimeDepositAmt" || fieldName === "newTransferAmt"){
                const remainder = +amount % 1000;
                if (remainder !== 0){
                    const errorMsg = fieldLabel + " for CDs must be a multiple of $1000.";
                    this.setErrorMsg(fieldName, errorMsg);
                }
            }
            this.transferExceedsCD = false;
            if (fieldName === "newTransferAmt" && this.currentCD === true){
                if (+amount > this.currentCDAmt){
                    this.transferExceedsCD = true;
                } 
            }
        }
    }

    setErrorMsg(fieldName, errorMsg){
        this.fieldInError = true;
        if (!this.amountErrorArr.includes(fieldName)){
            this.amountErrorArr.push(fieldName);
        }
        switch (fieldName){
            case "oneTimeDepositAmt":
                this.oneTimeAmtError = errorMsg;
                break;
            case "monthlyDepositAmt":
                this.monthlyAmtError = errorMsg;
                break;
            case "newTransferAmt":
                this.transferAmtError = errorMsg;
                break;
            default:
                break;
        }
    }
               
    displayFriendModal(){
        this.askAFriendInfo = {topic: "setupSavings"}
        this.setState({openFriendModal: true});
    }

    closeFriendModal(){
        this.setState({openFriendModal: false});
    }
    
    processCDList(){
        const transferAmt = this.props.savingsInfo.newTransferAmt;
        this.CDList = this.props.CDList;
        const CDListObj = checkCDListForChanges(this.CDList, this.props.gameDate, transferAmt);
        this.CDListHasBeenChanged = CDListObj.CDListHasBeenChanged;
        this.currentCD = CDListObj.currentCD;
        this.chgAutoRollover = CDListObj.chgAutoRollover;
        this.CDInstructions = CDListObj.CDInstructions;
        this.currentCDAmt = CDListObj.currentCDAmt;
    }

    determineDisplayControls(){
        if (this.transferFee === 0){
            if ((this.props.savingsInfo.savingsType === "CD" && 
                (this.currentCD === false || this.transferExceedsCD === true)) ||
                    this.props.savingsInfo.savingsClass === "retirement"){
                this.transferNotRecommended = true;
                this.notRecommendedText = "Not Recommended";
                if (this.props.savingsInfo.savingsType === "CD"){
                    this.notRecommendedText += " at This Time";
                }else{
                    if (this.props.savingsInfo.savingsClass === "retirement"){
                        this.notRecommendedText += " for Retirement Accounts"
                    }
                }
            }
        }
    }

    rerender(){
        this.setState({rerender: true});
    }

    render() {
        if (this.props.savingsInfo.savingsType === "CD"){
            this.processCDList();
            this.CDListDisplay = this.CDList.map((CDItems, key) =>
                <SavingsCDList key={key} tableInfo={CDItems} 
                    tableType={"date-amount-string-string"} 
                    updateCDList={(CDObj) => this.props.updateCDList(CDObj)} 
                    processCDList={() => this.rerender()}/>
                );
        }
        this.featuresList = this.savingsPolicyData.featuresArr.join(', ');
        this.determineDisplayControls();
        const scrollable = true;
    return <>
      
    <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="lg" 
            dialogClassName="moneyBuilder-modal-size" animation={false}>
        <Modal.Header className="backgroundTopBottom " closeButton>
            <Modal.Title className="text-center">Setup Policies for {this.savingsTypeLabel}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
            <div className= "mt-2">
                <h5 className="text-center">Game and Summary Information</h5>
                <SavingsGeneralDisplay
                    step={this.props.step}
                    savingsClass={this.props.savingsClass}
                    fieldErrors={this.props.fieldErrors}
                    summaryData={this.props.summaryData}
                    callingProcess={"detail"}
                />
            </div>
            <hr style={{ border: '1px solid black', margin: '5px 0' }} />
            <div className={`modal-body ${scrollable ? 'scrollable' : ''}`}>
                <h5 className="text-center mt-0">Account Information</h5>
                <div className="mt-2">
                    <SetupSavingsCardDisplay
                        savingsClass={this.props.savingsClass}
                        savingsInfo={this.props.savingsInfo}
                        callingProcess={"modal"}
                        currentGameDate={this.props.gameDate}
                    />          
                </div>
                
                 {this.props.savingsInfo.savingsType === "CD"  && this.props.CDList.length > 0 ?
                        <>
                        <hr style={{ border: '1px solid black', margin: '10px 0' }} />
                        <div>
                            <h5 className="text-center ">List of Active CDs</h5>
                            <table className="table table-borderless table-no-space ml-4">
                                <tbody>
                                    <tr>
                                        <th className="text-center p-0 "
                                            style={{ whiteSpace: 'normal', width: '80px' }}> 
                                            Maturity Date</th>
                                        <th className="text-center p-0"
                                            style={{ whiteSpace: 'normal', width: '80px' }}>
                                            CD Amount</th>
                                        <th className="text-center p-0"
                                            style={{ whiteSpace: 'normal', width: '80px' }}>
                                            Interest Earned</th>
                                        <th className="text-center p-0"
                                            style={{ whiteSpace: 'normal', width: '80px' }}>
                                            Auto Rollover
                                            </th>
                                        <th className="text-center p-0" 
                                            style={{ whiteSpace: 'normal', width: '80px' }}>
                                            New Auto Rollover
                                        </th>

                                        {this.props.savingsInfo.newTransferAmt > 0 ?
                                            <th className="p-2">Transfer Chg</th>
                                        :
                                            <th></th>
                                        }
                                    </tr>
                                        {this.CDListDisplay}
                                </tbody>
                            </table>
                           
                        </div>
                        </>
                    :
                        null
                    }   
                    <hr style={{ border: '1px solid black', margin: '5px 0' }}/>
                    {/* Transfer Amount (conditionally visible) */}
                    {this.props.savingsInfo.totalSavingsAmt > 0 ? (
                        <div className="mt-2 text-center">
                            <label className="font-weight-bold" htmlFor="newTransferAmt">
                            Withdrawal Amount:&nbsp;&nbsp;
                            <input type="text" id="newTransferAmt" name="newTransferAmt"
                                className="text-right"  value={this.props.savingsInfo.newTransferAmt}
                                style={{ width: '100px' }}
                                onChange={(e) => this.transferAmount(e.target.value)}
                            />
                            {this.transferNotRecommended  ?
                                <span className="text-warning ml-2">
                                    {this.notRecommendedText}
                                </span>
                            :
                                null
                            }
                            {this.props.transferFeeObj.transferFeeDisplay  &&
                                this.transferAmtError === "" ?
                                <div className="mx-4 bg-warning text-dark px-1 rounded">
                                    {this.props.transferFeeObj.transferFeeText}
                                </div>
                            :
                                null
                            }
                            </label>
                            <div className="text-danger">{this.transferAmtError}</div>
                        </div>
                    ) : null}
                    {this.props.savingsInfo.savingsType === "CD"  ?
                        <div className="text-center">
                            {this.CDInstructions}           
                        </div>            
                    :
                            <h6 className="mt-2 text-center">
                            ------------------------- Deposit Amounts -------------------------
                            </h6>
                    }

                <div className="row mt-2 mx-2">
                    <div className="col-sm-6">
                        <label className="font-weight-bold" htmlFor="oneTimeAmt">
                            One Time Amt:&nbsp;&nbsp;
                            <input type="text" id="oneTimeAmt" name="oneTimeAmt"
                                value={this.props.savingsInfo.oneTimeDepositAmt}
                                className="text-right" style={{ width: '100px' }}
                                onChange={(e) => this.onOneTimeDeposit(e.target.value)}
                            />
                        </label>
                        <div className="text-danger">{this.oneTimeAmtError}</div>
                    </div>

                    {this.props.savingsInfo.savingsType === "CD" ? (
                        <>
                        { this.chgAutoRollover === true ? 
                            <div className="col-sm-6">
                                <div className="ml-2">
                                    <label className="font-weight-bold" htmlFor="autoRollover">
                                        Auto Rollover?:&nbsp;&nbsp;
                                        <select  className="dropdown-toggle"
                                            value={this.props.savingsInfo.autoRollover} 
                                            onChange={(e) => this.autoRollover(e.target.value)}
                                            id="autoRollover" >
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </label>
                                </div>
                            </div>
               
                        :
                            null
                        }
                        </>
                    ) : (
                        <div>
                            <label className="font-weight-bold" htmlFor="monthAmt">
                                Monthly Amt:&nbsp;&nbsp;
                            <input type="text" id="monthAmt"  name="monthAmt"
                                style={{ width: '90px' }} className="text-right"
                                onChange={(e) => this.onMonthlyDeposit(e.target.value)}
                                value={this.props.savingsInfo.monthlyDepositAmt}
                            />
                            </label>
                            <div className="text-danger">{this.monthlyAmtError}</div>
                        </div>
                        )}
                    </div>
              </div>
        </Modal.Body>

        <Modal.Footer className="backgroundTopBottom ">
            {(this.amountError === false && this.dataChanged === true) || this.CDListHasBeenChanged ?
                <Button variant="secondary"  onClick={() => this.props.amountsSubmitted()} >
                    Submit Change
                </Button> 
            :
                null
            }
            <Button variant="primary"  onClick={() => this.props.onClose()}>
                    Close
            </Button>
           
        </Modal.Footer>
    </Modal>
    </>
    }

    componentDidMount() {
        if (this.props.show) {
            document.body.classList.add('modal-open');
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            document.body.classList.add('modal-open');
        } else if (!this.props.show && prevProps.show) {
            document.body.classList.remove('modal-open');
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('modal-open');
    }

    
}

export default SetupSavingsModal;